import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import ReactPlayer from "react-player";
import Typography from "@mui/material/Typography";

import MKBox from "components/MKBox";

import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

import bgFront from "assets/images/quadroEscuro.jpg";
import bgBack from "assets/images/QuadroVerde.jpg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    Educação
                    <br />
                    Matemática
                  </>
                }
                description="A Educação Matemática trouxe mudanças para o ensino, buscando refletir e superar o modelo tradicional, com excessos de fórmulas e repetições. Com isso o pesquisador e educador matemático Ubiratan D’Ambrósio, aponta esse como um caminho promissor, com práticas para estimular e fortalecer o aprendizado dos educandos e também promover a interdisciplinaridade."
              />
              <RotatingCardBack
                image={bgBack}
                title="Modelagem Matemática"
                description="Uma caracterização de Modelagem Matemática é que ela envolve uma problematização de situações do cotidiano em que o estudante está inserido e requer a elaboração/construção de um problema matemático para resolvê-lo. Nessa caracterização, a Modelagem, “ao mesmo tempo em que propõe a valorização do aluno no contexto social, procura levantar problemas que sugerem questionamentos sobre situações da vida” (PARANÁ, 2008, p. 64)."
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h4" align="center" color="#348ded" gutterBottom>
                  Educação Matemática
                </Typography>
                <MKBox sx={{ position: "relative", paddingTop: "56.25%" /* 16:9  */ }}>
                  <ReactPlayer
                    url="https://youtu.be/h0VacnNJmOg"
                    width="100%"
                    height="100%"
                    style={{ position: "absolute", top: 0, left: 0 }}
                    controls
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h4" align="center" color="#348ded" gutterBottom>
                  Modelagem Matemática
                </Typography>
                <MKBox sx={{ position: "relative", paddingTop: "56.25%" }}>
                  <ReactPlayer
                    url="https://youtu.be/8sHkP6qCzjg?si=lo0PmEiDmkNo0AyC"
                    width="100%"
                    height="100%"
                    style={{ position: "absolute", top: 0, left: 0 }}
                    controls
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 6 }} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="content_copy"
                  title="Evolução da Educação Matemática"
                  description="Exploração das mudanças no ensino, destacando o movimento longe do modelo tradicional."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="flip_to_front"
                  title="Abordagem da Modelagem Matemática"
                  description="Descrição e importância da abordagem que integra situações cotidianas ao aprendizado matemático."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="touch_app"
                  title="Enfoque Interdisciplinar"
                  description="Como a educação matemática promove a interdisciplinaridade, com destaque para a visão de Ubiratan D’Ambrósio."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Valorização do Aluno e Contexto Social"
                  description="Discussão sobre como a modelagem matemática valoriza o aluno dentro de seu contexto social e promove o questionamento crítico."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
